import { unravel } from '@/service/jsonApi'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import type { Ref } from 'vue'
import {
  getProductActivityItems,
  getProductsUserActivitySummary,
} from './activitiesApi'
import {
  QUERY_KEY_PRODUCT_ACTIVITY_ITEMS,
  QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY,
} from './activitiesKeys'

export const useUserActivitySummaryQuery = (
  productId: string,
  userId: string
) => {
  const query = useQuery({
    queryKey: [QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY, { productId, userId }],
    queryFn: () =>
      getProductsUserActivitySummary({
        productId,
        userId,
      }),
    enabled: computed(() => !!productId && !!userId),
    select: (data) => unravel(data),
  })
  return query
}

// Identical queryKey for the same productId means all row instances on a page
// share one in-flight request and one cache entry (dedup across N rows).
export const useProductActivityItemsQuery = (
  productId: string | number,
  options: { enabled: Ref<boolean> }
) => {
  const query = useQuery({
    queryKey: [QUERY_KEY_PRODUCT_ACTIVITY_ITEMS, String(productId)],
    queryFn: () => getProductActivityItems(productId),
    enabled: options.enabled,
    select: (data) => unravel(data),
  })
  return query
}
